import { useState, useMemo, ComponentType } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { stepToComponentMap } from '@/stepMappings'
import { useConfig } from '@/redux/partnerConfig/selectors'
import { StepConfig } from '@/types/partnerConfig'
import { setSignupRoutes } from '@/redux/signup/actions'
import { StepRoute } from '@/types/routes'
import { useOidcRegistration } from '@/redux/productConfig/selectors'
import { getFeatureFlags } from '@/components'

const getRoutes = (
  url: string,
  steps: StepConfig[],
  componentMap: { [key: string]: ComponentType }
): StepRoute[] =>
  steps.map(({ component, slug }) => ({
    key: slug,
    path: `${url}/${slug}`,
    component: componentMap[component],
    componentKey: component,
  }))

const useRoutes = () => {
  const dispatch = useDispatch()
  const { steps } = useConfig()
  const { url } = useRouteMatch()
  const devOidcEnabled = getFeatureFlags().oidc_enabled
  const oidcEnabled = useOidcRegistration()
  const componentMap = stepToComponentMap(!!oidcEnabled || !!devOidcEnabled)
  const [routes, setRoutes] = useState<StepRoute[]>(
    getRoutes(url, steps, componentMap)
  )

  useMemo(() => {
    const signupRoutes = getRoutes(url, steps, componentMap)
    setRoutes(signupRoutes)
    dispatch(setSignupRoutes(signupRoutes))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url])

  return {
    stepRoutes: routes,
    initialRoutePath: routes[0].path,
  }
}

export default useRoutes
